import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

import { useAuth } from "../../../context/AuthContext";

const AuthLayout = () => {
  const { authChecked, isAuthenticated, userRole, pendingEvaluationAthleteId } =
    useAuth();
  const location = useLocation();

  if (!authChecked) {
    return (
      <div className="flex h-screen items-center justify-center bg-white">
        <Loader2 className="animate-spin text-blue-900" size={32} />
      </div>
    );
  }

  if (isAuthenticated && location.pathname !== "/reset-password") {
    if (pendingEvaluationAthleteId) {
      return <Navigate to="/athlete/onboarding" replace />;
    }
    const target =
      userRole === "admin"
        ? "/admin"
        : userRole === "scout"
          ? "/scout/dashboard"
          : "/athlete/dashboard";
    return <Navigate to={target} replace />;
  }

  return <Outlet />;
};

export default AuthLayout;
